import axios from "axios";
import { API_KEY } from "constants/environment";
import { ENDPOINT } from "constants/environment";
import { API_HEADER } from "helpers";
import { decryptData } from "helpers";

export async function getAccessTokenAPI() {
  const URL = `${ENDPOINT}/app/v1/auth/passKey`;
  const config = {
    headers: API_HEADER,
    "x-api-key": API_KEY
  };

  try {
    const response = await axios.post(URL, "", config);
    if (response?.data) {
      const decryptedData = decryptData(response?.data);
      const parseData = JSON.parse(decryptedData);
      return parseData ? parseData : null;
    } else return null;
  } catch (error) {}
}
